import { render, staticRenderFns } from "./memberRule.vue?vue&type=template&id=40cb708f&scoped=true&"
import script from "./memberRule.vue?vue&type=script&lang=js&"
export * from "./memberRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb708f",
  null
  
)

export default component.exports